// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchCategoryResults_container__tYvzm","extraInfo":"SearchCategoryResults_extraInfo__S7BTA"};